import { computed } from "vue";
import { storeToRefs } from "pinia";

import { useMagStore } from "@/stores/modules/mag";

export const useMag = () => {
  const magStore = useMagStore();
  const {
    categories,
    category,
    posts,
    post,
    post_header,
    genres,
    rows,
    row_items,
    row_item,
    genres_posts
  } = storeToRefs(magStore);
  const widgets = computed(() => {
    if (row_item.value.magrowitems) {
      return row_item.value.magrowitems.find(item => item?.widgets?.length > 0);
    }
    return undefined;
  });

  const getCategories = async categorySlug => {
    await magStore.getCategories();
    // if (categorySlug) {
    //   category.find(category => category.slug === categorySlug);
    // }
  };
  const uploadPosts = async () => {
    await magStore.getPosts();
  };
  const uploadPost = async id => {
    await magStore.getPost(id);
  };
  const clearPost = async () => {
    await magStore.clearPost();
  };
  const uploadPostFilter = async params => {
    params.count = true;
    await magStore.getPostFilter(params);
  };
  const uploadGenres = async () => {
    await magStore.getGenres();
  };
  const uploadMagRowItemParam = async params => {
    await magStore.getMagRowItemsParam(params);
  };
  const uploadMagRowItems = async () => {
    await magStore.getMagRowItems();
  };
  const getGenrePosts = async genre => {
    await magStore.getGenrePosts(genre);
  };
  const getCategory = async categoryName => {
    await magStore.getCategory(categoryName);
  };
  const removeGenrePosts = genre => magStore.removeGenrePosts(genre);

  return {
    //! Properties
    categories,
    category,
    posts,
    post,
    genres,
    row_items,
    rows,
    row_item,
    post_header,
    widgets,
    genres_posts,
    //! Computed
    // imgSrc: computed(
    //   () =>
    //     `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/user/other/dream-world/${user.value?.id}.svg`
    // ),
    spotify: computed(() => {
      if (widgets.value) {
        return widgets.value.widgets.find(
          item =>
            item.widget_type === 1 && item.spotify.iframe.includes("spotify")
        );
      }
      return undefined;
    }),
    instagram: computed(() => {
      if (widgets.value) {
        return widgets.value.widgets.find(
          item =>
            item.widget_type === 6 &&
            item.instagram.iframe.includes("instagram")
        );
      }
      return undefined;
    }),
    top_artists: computed(() => {
      if (widgets.value) {
        return widgets.value.widgets.find(item => item.widget_type === 2);
      }
      return undefined;
    }),
    musical_diary: computed(() => {
      if (widgets.value) {
        return widgets.value.widgets.find(item => item.widget_type === 3);
      }
      return undefined;
    }),
    competition: computed(() => {
      if (widgets.value) {
        return widgets.value.widgets.find(item => item.widget_type === 4);
      }
      return undefined;
    }),
    socialMedia: computed(() => {
      if (widgets.value) {
        return widgets.value.widgets.find(item => item.widget_type === 0);
      }
      return undefined;
    }),
    principal_img: computed(() => {
      if (post.value.images) {
        return post.value.images.find(img => img.is_principal === true);
      }
      return undefined;
    }),
    tag_category: computed(() => {
      if (post.value.tags) {
        return post.value.tags.filter(tag => tag.is_category === true);
      }
      return undefined;
    }),
    extra_video: computed(() => {
      if (post.value.images) {
        return post.value.images.filter(img => img.extra_video === true);
      }
      return undefined;
    }),
    last_post: computed(() => {
      if (posts.value.magposts) {
        return posts.value.magposts.filter(item => item.last_post === true);
      }
      return undefined;
    }),
    //! Metodos
    getCategories,
    uploadPosts,
    uploadPost,
    clearPost,
    uploadGenres,
    uploadMagRowItemParam,
    uploadPostFilter,
    uploadMagRowItems,
    getGenrePosts,
    removeGenrePosts,
    getCategory
  };
};
